import React, { ChangeEventHandler } from "react";

interface SelectedProps {
  children?: React.ReactNode;
  text?: string;
  title?: string;
  name?: string;
  value?: string;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  className?: string;
  sss?: string;
  optionValue?: boolean;
  defaultValue?: number | string;
  defaultChecked ?:any
}

const Selected: React.FC<SelectedProps> = ({
  children,
  text,
  title,
  name,
  value,
  onChange,
  className,
  sss,
  optionValue,
  defaultValue,
  defaultChecked
}) => {
  return (
    <div className="max-md:my-0">
      {text && (
        <h1 className={`text-start text-sm font-bold mx-1  mt-3 ${sss}`}>{text}</h1>
      )}
      <select
        name={name}
        value={value}
        onChange={onChange}
        defaultValue={defaultValue}
        defaultChecked={defaultChecked}
     
        className={`w-full border mt-3 !border-Secondary text-gray-400 bg-[#F6F8F9] shadow-sm  py-4 rounded-xl   outline-none ${className}`}
      >
        <option value="" disabled selected hidden>
          {title}
        </option>
        {optionValue && (
          <option value="1" selected>
            غير مقبولة
          </option>
        )}
        {children}
      </select>
    </div>
  );
};

export default Selected;
